<!-- <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-clip-rotate" [fullScreen]="true">
    <p style="color: white">{{ spinnerText }}</p>
</ngx-spinner> -->

<ngx-spinner bdColor="rgba(255,255,255,0.65)" [fullScreen]="true" type="none">

    <div class="custom-loader">
        <div class="loader-ring"></div>
        <div class="loader-content">
            <h6>{{ spinnerText || 'Loading...' }}</h6>
            <small>Please wait a moment</small>
        </div>
    </div>

</ngx-spinner>

<router-outlet></router-outlet>


<app-toast-control style="position: absolute; bottom: 5px; right: 5px" aria-live="polite"
    aria-atomic="true"></app-toast-control>